
export default {
  NORMAL:0,
  CANCELAMENTO: 1,
  DEVOLUCAO:2,
  CORRECAO:3
};
